import { Button as CXButton, IButton as CXIButton } from '@sanlamcx/react-ui-next-button';

export const BUTTON_COLOR = CXButton.COLOR;
export const BUTTON_SIZE = CXButton.SIZE;
export const BUTTON_VARIANT = CXButton.VARIANT;
export const Button = CXButton;
export type IButton = CXIButton;
